import PropTypes from 'prop-types'

const DetailsItem = ({ data, title }) => (
  <div>
    <span className="details-title">{title}</span>
    <table className="details-item">
      <tbody>
        {data.map(
          (element, index) =>
            !element.hidden && (
              <tr key={`${+index}_${element.title}`}>
                {element.label ? (
                  <td>
                    <span>{element.title}</span>
                    <span>{element.label}</span>
                  </td>
                ) : (
                  <>
                    <td>{element.title}</td>
                    <td>{element.value}</td>
                  </>
                )}
              </tr>
            ),
        )}
      </tbody>
    </table>
  </div>
)

DetailsItem.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
}

export default DetailsItem
